import React, { Component } from "react";
// core components
import NavPills from "components/NavPills/NavPills.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import MUIDataTable from "mui-datatables";
import SearchIco from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.jsx";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchChangedestAll } from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushPoiTarget } from "actions/portal";
import { withRouter } from "react-router-dom";

class Changedest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: []
    };
  }

  componentDidMount() {
    fetchChangedestAll()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  handleRowSelect = e => {
    this.props.pushLeftPanel(!this.props.leftPanel);
    this.props.pushPoiTarget([e[3], e[4]]);
  };

  render() {
    const columns = [
      {
        name: "shipid",
        label: "Shipid",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "name",
        label: "Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "etastd",
        label: "Etastd",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "dest",
        label: "Destination",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "destcode",
        label: "Destination Code",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "from",
        label: "From",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "eta",
        label: "ETA",
        options: {
          filter: false,
          display: true
        }
      }
    ];

    const options = {
      filter: false,
      search: false,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      onRowClick: e => {
        this.handleRowSelect(e);
      }
    };

    return (
      <MUIDataTable
        data={this.state.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

Changedest.propTypes = {
  pushLeftPanel: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushPoiTarget }
)(Changedest));
